import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_FORM_PDF_REQUEST = 'GET_FORM_PDF_REQUEST';
export const GET_FORM_PDF_SUCCESS = 'GET_FORM_PDF_SUCCESS';
export const GET_FORM_PDF_FAILURE = 'GET_FORM_PDF_FAILURE';

function request() {
  return {
    type: GET_FORM_PDF_REQUEST,
    isFetchingPdfForm: true
  };
}

function receive(pdfData) {
  return {
    type: GET_FORM_PDF_SUCCESS,
    isFetchingPdfForm: false,
    pdfData,
  };
}

function reject() {
  return {
    type: GET_FORM_PDF_FAILURE,
    isFetchingPdfForm: false
  };
}

export function getPreviewPdf(formId) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .getPreviewPdf(formId, { responseType: 'arraybuffer' })
      .then((response) => {
        dispatch(receive(response.data));
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          const status = error.response && error.response.status;
          if (status !== 401) {
            dispatch(handleException(
              { response: { data: { code: 500, message: 'Sorry, there was a problem downloading your pdf.  Please try again.' } } },
              reject,
              !status || (status !== 404 && status !== 401)
            ));
          }
        }
      });
    return promise();
  };
}

export function getFormPdf(formId) {
  return (dispatch) => {
    dispatch(request());

    return ApiService
      .getFormPdf(formId, { responseType: 'arraybuffer' })
      .then((response) => {
        dispatch(receive(response.data));
      }).catch((error) => {
        const status = error.response && error.response.status;
        if (status !== 401) {
          dispatch(handleException(
            { response: { data: { code: 500, message: 'Sorry, there was a problem downloading your signed pdf.  Please try again.' } } },
            reject,
            !status || (status !== 404 && status !== 401)
          ));
        }
      });
  };
}
